import { render, staticRenderFns } from "./NovoBaranje.vue?vue&type=template&id=dbeef180&scoped=true"
import script from "./NovoBaranje.vue?vue&type=script&lang=js"
export * from "./NovoBaranje.vue?vue&type=script&lang=js"
import style0 from "./NovoBaranje.vue?vue&type=style&index=0&id=dbeef180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbeef180",
  null
  
)

export default component.exports